import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-features-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './features-section.component.html',
  styleUrl: './features-section.component.css'
})
export class FeaturesSectionComponent {
  features = [
    {
      icon: 'chat.svg',
      title: 'Real-time Chat',
      description: 'Connect instantly with hosts and other attendees through 1-on-1 and group messaging. Stay in the loop with real-time updates.',
      highlight: true
    },
    {
      icon: 'event-discovery.svg',
      title: 'Event Discovery',
      description: 'Browse events with advanced filters for location, date and attendee count. Find events that match your vibe.',
      highlight: false
    },
    {
      icon: 'entering-door.svg',
      title: 'Secure Entry',
      description: 'DropAddy check-in system ensures safe and verified entry. Hosts can manage guest lists with ease and security.',
      highlight: false
    },
    {
      icon: 'user-profiles.svg',
      title: 'User Profiles',
      description: 'Build your party reputation with verified profiles, social links, and party history. Connect with like-minded people.',
      highlight: false
    },
    {
      icon: 'diamond.svg',
      title: 'Premium Features',
      description: 'Unlock exclusive parties with paid subscriptions, get early access to events, priority support, and special badges.',
      highlight: false
    },
    {
      icon: 'shield-check.svg',
      title: 'Safety First',
      description: 'Report inappropriate behavior, verify identities, and use location sharing. Your safety is our top priority.',
      highlight: false
    }
  ];
}
